import parigp from "refractor/parigp";
export default parigp;